import React, { memo, useEffect } from 'react';
import { FormSubmissionValues, SetFormSubmissionValues } from '@modules/forms/types';
import { APISurveyScreen } from '@modules/survey/types/objects';
import ScreenComponents from '@common/components/form/user-response-fields/screen-components';
import { Screen } from '@modules/learning/types/objects';

type SubmissionEditorStepProps = {
  screen: APISurveyScreen | Screen;
  value: FormSubmissionValues;
  setValues: SetFormSubmissionValues;
  showCorrectAnswers?: boolean;
  outcomePhase?: boolean;
};

const SubmissionEditorStep = memo(({
  screen,
  value,
  setValues,
  ...otherProps
}: SubmissionEditorStepProps) => {

  useEffect(() => {
    // we want the step to be at the top of its viewport when
    // we navigate the survey
    window.scrollTo(0, 0);
  }, []);

  return (
    <ScreenComponents
      screen={screen}
      values={value}
      setValues={setValues}
      readOnly={false}
      {...otherProps}
    />
  );

});

export default SubmissionEditorStep;
